export interface Size {
  width: number;
  height: number;
}

export function getImageSize(imageUrl: string): Promise<Size> {
  return new Promise((resolve) => {
    const image = new Image();
    image.onload = () => {
      resolve({
        width: image.width,
        height: image.height,
      });
    };
    image.src = imageUrl;
  });
}
